import React, { useEffect, useRef, useState } from "react";
import { Grid, _ } from "gridjs-react";
// import { h } from "gridjs";
import "gridjs/dist/theme/mermaid.css";
import moment from "moment";
import Loading from "../components/loading";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrashAlt,
  faUndoAlt,
} from "@fortawesome/free-solid-svg-icons";
import Scrim from "../components/Scrim";
import CopyButton from "../components/copyButton";
import { OlindaService } from "../services/apiOlinda";
import CopyButtonSection from "../components/copyButtonSection";

/**
 *
 * @param {Object} props
 * @param {Array<Object>} props.dados
 * @param {() => void} props.listarServicos
 * @param {[buttonLabel: string, { className: string, title: string, apiCall?: (idConsumidorServico: number) => Promise<import("axios").AxiosResponse } ][]} [props.listaBotoes]
 * @param {boolean} [props.isServicoConsumidor]
 * @param {string} [props.tokenAcesso]
 * @returns
 */
function TabelaServicos(props) {
  const [modal, setModal] = useState(false);
  const [mensagemErro, setMensagemErro] = useState("");
  const [nomeServico, setNomeServico] = useState("");
  const [showDeleteModal, setshowDeleteModal] = useState(false);
  const [deleteFunction, setDeleteFunction] = useState(undefined);
  /**
   * @type {import("../types").useState<{ [serviceKey: string | number] : import("../types").Consumidor[] }>}
   */
  const [consumidoresServicos, setConsumidoresServicos] = useState({});
  const fetched = useRef(false);

  const editIcon = <FontAwesomeIcon icon={faEdit} fixedWidth />;
  const inativarIcon = <FontAwesomeIcon icon={faTrashAlt} fixedWidth />;
  const ativarIcon = <FontAwesomeIcon icon={faUndoAlt} fixedWidth />;

  if (!props.listaBotoes) {
    throw new Error(
      "Tabela de Servicos: necessario passar botoes de acao como props!"
    );
  }

  const listaBotoes = new Map(props.listaBotoes);

  useEffect(() => {
    if (fetched.current || props.tokenAcesso || props.isServicoConsumidor) {
      return;
    }
    fetched.current = true;
    (async () => {
      try {
        const [consumidoresServico, consumidoresReq] = await Promise.all([
          OlindaService.listarTodosServicosConsumidor(),
          OlindaService.listarconsumidor(),
        ]);

        const consumidores = consumidoresReq.data["data"];

        /**
         * @type {{ [servicoKey: string] : import("../types").Consumidor[] }}
         */
        const listaConsumidoresServicos = {};
        consumidoresServico.forEach((relacao) => {
          if (listaConsumidoresServicos[relacao["id_servicos_olinda"]]) {
            listaConsumidoresServicos[relacao["id_servicos_olinda"]].push(
              consumidores.find(
                (consumidor) =>
                  consumidor["id_consumidor"] === relacao["id_consumidor"]
              )
            );
            return;
          }
          listaConsumidoresServicos[relacao["id_servicos_olinda"]] = [
            consumidores.find(
              (consumidor) =>
                consumidor["id_consumidor"] === relacao["id_consumidor"]
            ),
          ];
        });

        setConsumidoresServicos(listaConsumidoresServicos);
      } catch (err) {
        console.log("Erro ao tentar obter relaçoes de servico", err);
      }
    })();
  }, []);

  /**
   *
   * @param {number} id
   * @param {(id: number) => Promise<any>} apiCall
   */
  function handleAPICall(id, apiCall) {
    if (props.listaBotoes) {
      setModal(true);
      apiCall(id)
        .then((resposta) => {
          props.listarServicos();
          setModal(false);
        })
        .catch((error) => {
          let errorMsg = "";

          if (error.response) {
            errorMsg = error.response;
          } else {
            errorMsg = "Erro desconhecido, contante o administrador.";
          }

          setMensagemErro(errorMsg);
          setModal(false);
        });
    }
  }

  const handleEdit = (id) => {
    window.location = "../editar-servico/" + id;
  };

  function askForDeletion(delFunction, serviceName) {
    setshowDeleteModal(true);
    setDeleteFunction(() => delFunction);
    setNomeServico(serviceName);
  }

  const language = {
    search: {
      placeholder: " 🔍 Pesquisar",
    },
    pagination: {
      previous: "Anterior",
      next: "Próximo",
      showing: "Mostrando",
      results: () => "registros",
      to: "a",
      of: "de",
    },
  };

  return (
    <div>
      <Loading showModal={modal} />
      <Scrim
        title={"Tem Certeza?"}
        desc={
          <p>
            Deseja realmente desativar <strong>{nomeServico}</strong>?
          </p>
        } // String | Component
        buttons={[
          {
            label: "Sim",
            action: () => {
              deleteFunction();
            },
            class: "primary",
          },
          {
            label: "Não",
            action: () => {
              setshowDeleteModal(false);
            },
            class: "secondary",
          },
        ]}
        showModal={showDeleteModal}
        onModalActiveChange={(modalisActive) => {
          if (!modalisActive) {
            setshowDeleteModal(false);
          }
        }}
      />

      <Grid
        data={props.dados}
        search={true}
        columns={[
          {
            id: "id_servicos_olinda",
            hidden: true,
          },
          {
            id: "id_consumidor_servicos",
            hidden: true,
          },
          {
            id: "nome_servico",
            name: "Nome do Serviço",
          },
          {
            id: "servico_publico",
            name: "Tipo Serviço",
            data: (row) => {
              if (row.servico_publico == 1) {
                return "Público";
              } else {
                return "Privado";
              }
            },
          },
          {
            id: "deleted_at",
            name: "Situação",
            data: (row) => {
              if (row.deleted_at == null) {
                return "Ativo";
              } else {
                return (
                  "Inativo em " + moment(row.deleted_at).format("DD/MM/YYYY")
                );
              }
            },
          },
          {
            id: "url_servico_pronta",
            hidden: true,
          },
          {
            name: "Ações",
            formatter: (cell, row) => {
              const isAtivo = row.cells[4].data === "Ativo";

              const idConsumidorServico = row.cells[1].data;
              const idServico = row.cells[0].data;
              const serviceName = row.cells[2].data;
              const isPublico = row.cells[3].data === "Público";
              const URLServicoCopy = row.cells[5].data;

              const realId = props.isServicoConsumidor
                ? idConsumidorServico
                : idServico;

              let activationButtonProps = undefined;
              let EditButton = undefined;

              if (isAtivo) {
                activationButtonProps = listaBotoes.get("Desativar");
                activationButtonProps.children = "Inativar";

                const editButtonProps = listaBotoes.get("Editar");
                editButtonProps.children = "Editar";

                EditButton = (
                  <button
                    className={editButtonProps.className}
                    style={{ margin: "0.1rem" }}
                    title={editButtonProps.title}
                    onClick={(event) => {
                      event.preventDefault();

                      handleEdit(idServico);
                    }}
                  >
                    {editButtonProps.children}
                  </button>
                );
              } else {
                activationButtonProps = listaBotoes.get("Ativar");
                activationButtonProps.children = "Ativar";
              }

              const ActivationButton = (
                <button
                  className={activationButtonProps.className}
                  title={activationButtonProps.title}
                  onClick={(event) => {
                    event.preventDefault();

                    if (isAtivo) {
                      askForDeletion(
                        () =>
                          handleAPICall(realId, activationButtonProps.apiCall),
                        serviceName
                      );
                    } else {
                      handleAPICall(realId, activationButtonProps.apiCall);
                    }
                  }}
                >
                  {activationButtonProps.children}
                </button>
              );

              if (isAtivo) {
                return _(
                  <div style={{ gap: "3px", display: "flex" }}>
                    {EditButton} {ActivationButton}
                    <CopyButtonSection
                      isServicoPublico={isPublico}
                      listaConsumidoresServicos={
                        consumidoresServicos[idServico]
                      }
                      isServicoConsumidor={props.isServicoConsumidor}
                      nomeServico={serviceName}
                      tokenAcesso={props.tokenAcesso}
                      customURLformat={
                        URLServicoCopy
                          ? (servico, tokenAcesso) => {
                              if (isPublico) {
                                return `${URLServicoCopy}?servico=${servico}`;
                              }
                              return `${URLServicoCopy}?servico=${servico}&token_acesso=${tokenAcesso}`;
                            }
                          : undefined
                      }
                    />
                  </div>
                );
              }

              return _(
                <div style={{ gap: "3px", display: "flex" }}>
                  {ActivationButton}
                </div>
              );

              //   const ActivationButtonTransform = h(
              //     "button",
              //     ActivationButton.props,
              //     activationButtonProps.children
              //   );
              //   const EditButtonTransform =
              //     EditButton && h("button", EditButton.props, "Editar");
              //   const CopyButtonTransform = h(
              //     "button",
              //     CCButton.props,
              //     CCButton.children
              //   );

              //   return h(
              //     "div",
              //     {
              //       className: "action-buttons",
              //       style: { display: "flex", gap: "5px" },
              //     },
              //     [
              //       EditButtonTransform,
              //       ActivationButtonTransform,
              //     ]
              //   );
            },
          },
        ]}
        pagination={{
          limit: 5,
        }}
        language={language}
      />
    </div>
  );
}

export default TabelaServicos;
